import axios, { AxiosResponse } from "axios";
import {
  ITelemedicineAttendanceByIdParams,
  ITelemedicineAttendanceByIdPayload,
  ITelemedicineAttendancesCreateMeetPayload,
  ITelemedicineAttendancesGetBiomeasuresPayload,
  ITelemedicineAttendancesRequestPayload,
  ITelemedicineAttendancesUpdateStatusPayload,
  ITelemedicineAttendancesChangeRoomInProviderPayload,
  ITelemedicineCancelDocumentPayload,
  ITelemedicineCreateDocumentPayload,
  ITelemedicineGetDocumentsPayload,
  ITelemedicineAttendancesGuestDataRequestParams,
  ITelemedicineAttendanceGuestDataPayload,
  ITelemedicineAttendancesCreateConsentTermPayload,
} from "./types";
import { call, put } from "redux-saga/effects";
import {
  loadFailure,
  loadSuccess,
  loadSuccessAttendanceById,
  loadSuccessCancelDocument,
  loadSuccessCreateDocument,
  loadSuccessCreateMeet,
  loadSuccessGetBiomeasuresByAttendance,
  loadSuccessGetDocumentsByType,
  loadSuccessUpdateStatus,
  loadSuccessGuestData,
  loadSuccessChangeRoomInProvider,
  loadSuccessCreateConsentTerm,
} from "./actions";
import { apiSollar } from "../../../services/axios";
import { toast } from "react-toastify";

const path =
  "/telemedicine/attendances";

const path2 = "/telemedicine/attendance"

const pathDocs = "/telemedicine/docs"
const pathGuest = "/telemedicine/guest"

export function* getPatientsForTelemedicine({
  payload,
}: ITelemedicineAttendancesRequestPayload) {
  try {
    let response: AxiosResponse;
    response = yield call(
      apiSollar.get as any,
      `${path}/show?limit=${
        payload.limit ? payload.limit : 10
      }&page=${payload.page || 1}&attendance_type=${
        payload.attendance_type
      }&patient_name=${payload.patient_name || 'all'}`,
    );

    yield put(loadSuccess(response.data));
  } catch (error) {
    toast.error("Erro ao buscar informações da lista de Telemedicina");
    yield put(loadFailure());
  }
}

export function* getAttendanceMeetUrl({
  payload,
}: ITelemedicineAttendancesCreateMeetPayload) {
  try {
    let response: AxiosResponse;
    response = yield call(
      apiSollar.post as any,
      `${path2}/generateUrl`,
      payload
    );

    toast.success("Sala gerada com sucesso!");
    yield put(loadSuccessCreateMeet(response.data));
  } catch (error) {
    toast.error("Erro ao gerar link da sala para o atendimento");
    yield put(loadFailure());
  }
}

export function* updateAttendance({
  payload,
}: ITelemedicineAttendancesUpdateStatusPayload) {
  try {
    let response: AxiosResponse;
    response = yield call(
      apiSollar.post as any,
      `${path2}/update?_id=${
        payload._id
      }`,
      {...payload}
    );

    toast.success("Atendimento finalizado com sucesso!");
    yield put(loadSuccessUpdateStatus(response.data));
  } catch (error) {
    toast.error("Erro ao atualizar status do atendimento");
    yield put(loadFailure());
  }
}

export function* getTelemedicineDocumentsByType({
  payload,
}: ITelemedicineGetDocumentsPayload) {
  try {
    let response: AxiosResponse;
    response = yield call(
      apiSollar.get as any,
      `${pathDocs}/show?telemedicine_attendance_id=${payload?.telemedicine_attendance_id}&document_type=${payload?.document_type}`,
    );
    response.data.document_type = payload.document_type
    yield put(loadSuccessGetDocumentsByType(response.data));
  } catch (error) {
    toast.error("Erro ao buscar documentos do atendimento");
    yield put(loadFailure());
  }
}

export function* createTelemedicineDocument({
  payload,
}: ITelemedicineCreateDocumentPayload) {
  try {
    let response: AxiosResponse;
    response = yield call(
      apiSollar.post as any,
      `${pathDocs}/store`,
      payload
    );

    yield put(loadSuccessCreateDocument());
  } catch (error) {
    toast.error("Erro ao criar documento");
    yield put(loadFailure());
  }
}

export function* cancelTelemedicineDocument({
  payload,
}: ITelemedicineCancelDocumentPayload) {
  try {
    let response: AxiosResponse;
    response = yield call(
      apiSollar.post as any,
      `${pathDocs}/cancel?_id=${payload._id}`,
      {canceled_reason: payload.canceled_reason}
    );

    yield put(loadSuccessCancelDocument());
  } catch (error) {
    // toast.error("Erro ao cancelar documento");
    yield put(loadFailure());
  }
}

export function* getBiomeasuresByAttendance({
  payload,
}: ITelemedicineAttendancesGetBiomeasuresPayload) {
  try {
    let response: AxiosResponse;
    response = yield call(
      apiSollar.get as any,
      `${path2}/biomeasures?attendance_id=${payload?.attendance_id}`,
    );

    yield put(loadSuccessGetBiomeasuresByAttendance(response.data));
  } catch (error) {
    toast.error("Erro ao buscar biomedidas do paciente");
    yield put(loadFailure());
  }
}

export function* getAttendanceById({
  payload,
}: ITelemedicineAttendanceByIdPayload) {
  try {
    let response: AxiosResponse;
    response = yield call(
      apiSollar.get as any,
      `${path2}/show/${payload?.attendance_type}/${payload?.id}?medical_opinion_id=${payload?.medical_opinion_id}`,
    );

    yield put(loadSuccessAttendanceById(response.data));
  } catch (error) {
    toast.error("Erro ao buscar dados do paciente");
    yield put(loadFailure());
  }
}

export function* getTelemedicineGuestData({
  payload,
}: ITelemedicineAttendanceGuestDataPayload) {
  try {
    let response: AxiosResponse;
    response = yield call(
      apiSollar.post as any,
      `${pathGuest}/check`,
      payload
    );
    yield put(loadSuccessGuestData(response.data));
  } catch (error: any) {
    // console.log(error)
    toast.error(error?.response?.data?.message || 'Atendimento não encontrada');
    yield put(loadFailure());
  }
}

export function* changeRoomInProvider({
  payload,
}: ITelemedicineAttendancesChangeRoomInProviderPayload) {
  try {
    let response: AxiosResponse;
    response = yield call(
      apiSollar.patch as any,
      `telemedicine/room/provider/in/${payload._id}/${payload.in}`
    );

    yield put(loadSuccessChangeRoomInProvider(response.data));
  } catch (error) {
    toast.error("Erro ao atualizar presença no atendimento");
    yield put(loadFailure());
  }
}
export function* createConsentTerm({
  payload,
}: ITelemedicineAttendancesCreateConsentTermPayload) {
  try {
    let response: AxiosResponse;
    response = yield call(
      apiSollar.post as any,
      `telemedicine/term`,
      payload
    );

    yield put(loadSuccessCreateConsentTerm(response.data));
  } catch (error) {
    toast.error("Erro ao criar o termo de consentimento");
    yield put(loadFailure());
  }
}
